import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { TextArea } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import SubmitButton from "components/common/SubmitButton";

const BillRequestRejectDialog = ({
  open,
  loading,
  rejectReason,
  onReasonChange,
  onClose,
  onReject,
}) => {
  if (!open) return null;

  return (
    <Dialog title="Reject Bill" onClose={onClose} width={460}>
      <div className="p-3">
        <Label className="label mb-2 d-block">Rejection Reason</Label>
        <TextArea
          className="w-100"
          rows={5}
          value={rejectReason}
          onChange={onReasonChange}
          placeholder="Enter reason for rejection..."
          style={{ resize: "none" }}
        />
      </div>
      <div className="dialog-footer d-flex justify-content-end gap-2">
        <Button
          className="common-btn bgBtnSecondary"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </Button>
        <SubmitButton
          className="common-btn me-3"
          onClick={onReject}
          disabled={loading || !rejectReason.trim()}
          isLoading={loading}
        >
          Reject
        </SubmitButton>
      </div>
    </Dialog>
  );
};

export default BillRequestRejectDialog;
